import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import ProductGallery from './ProductGallery';
import ProductSelect from './ProductSelect';
import ProductInfo from './ProductInfo';
import ProductShare from './ProductShare';
import ProductDownload from './ProductDownload';
import ProductRelated from './ProductRelated';
import ProductFabrics from './ProductFabrics';
import ProductEnquire from './ProductEnquire';
import Foot from './Foot';

const Product = ({context}) => {
	
	if (context.posts){
		
	    const posts = () => context.posts;
	    const item = posts()[0];  
	    				
		const ctxPageLoaded = () => context.pageLoaded;
	    const pageLoaded = ctxPageLoaded();
	    
	    const ctxUserID = () => context.user.id;
		let userID = ctxUserID();
		
		if (userID === -1 || userID === null || userID == 'false') {
			userID = false;
		}
	    	    	    
	    let pageClass = 'c-page-wrapper state-not-loaded';
	    if (pageLoaded == true) {
		    pageClass = 'c-page-wrapper state-loaded';
	    }
	    
	    function toggleLogin(evt) {
			evt.preventDefault();
			context.toggleLogin();
		}
		
		function Pricing() {
			if (userID == false || userID == 'false' || userID === null || userID === -1) {
				return null;
			} else if (item) {
				if (item.price_html && item.rrp_html) {
					if (item.price_html.indexOf('<del') === -1) {
						return (
						
							<div className="c-product__price-cols c-product__price-cols--even">
								<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<h3>Trade Price</h3><p>' + item.price_html + ' <span class="ex-gst">Ex. GST</span></p>'} }></div>
								<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<h3>RRP</h3><p>' + item.rrp_html + ' <span class="ex-gst">Ex. GST</span></p>'} }></div>
							</div>
						);
					} else {
						return (
						
							<div className="c-product__price-cols">
								<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<h3>Trade Price</h3><p>' + item.price_html + ' <span class="ex-gst">Ex. GST</span></p>'} }></div>
								<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<h3>RRP</h3><p>' + item.rrp_html + ' <span class="ex-gst">Ex. GST</span></p>'} }></div>
							</div>
						);
					}
				} else if (item.price_html) {
					return (
						<div className="c-product__price-cols">
							<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<h3>Trade Price</h3><p>' + item.price_html + ' <span class="ex-gst">Ex. GST</span></p>'} }></div>
						</div>
					)
				} else if (item.rrp_html) {
					return (
						<div className="c-product__price-cols">
							<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<h3>RRP</h3><p>' + item.rrp_html + ' <span class="ex-gst">Ex. GST</span></p>'} }></div>
						</div>
					)
				} else if (item.poa == 'true' || item.poa == true) {
					return (<div className="scope-product-price" dangerouslySetInnerHTML={ {__html: '<p>Price On Application</p>'} }></div>);
				} else {
					return null;
				}
				
			}
		}
		
		function ProductStock() {
			if (typeof(item.stock_status) != "undefined") {
				if (item.stock_status == '' || item.stock_status === false || item.stock_status === null) {
					return null;
				} else if (item.stock_status == 'In stock' || item.stock_status == 'In Stock') {
					return (
						<p className="c-product__stock">Stock status<span className="c-product__stock__status">In Stock <b>(Dispatch/Collect in 24 hours)</b></span></p>
					)
				} else if (item.stock_status == 'Low stock' || item.stock_status == 'Low Stock') {
					return (
						<p className="c-product__stock">Stock status<span className="c-product__stock__status c-product__stock__status--low">Low Stock <b>(Dispatch/Collect in 24 hours)</b></span></p>
					)
				} else if (item.stock_status == 'Enquire' || item.stock_status == 'enquire') {
					return (
						<p className="c-product__stock">Stock status<span className="c-product__stock__status">Please Enquire</span></p>
					)
				} else {
					if (item.stock_status.trim().length > 1) {
						return (
							<p className="c-product__stock">Stock status<span className="c-product__stock__status">{ item.stock_status }</span></p>
						)
					} else {
						return null;
					}
				}
			} else {
				return null;
			}
		}
		function ProductButtons() {
			if (userID && item.price_html) {
				return (
					<>
						<ProductStock></ProductStock>
						<div className="c-product__buttons">
							<button className="c-product__buttons__button" onClick={addToCart}>Add To Cart</button>
							<ProductEnquire title={item.title} sku={item.sku} butClass={"c-product__buttons__button c-product__buttons__button--outline"}></ProductEnquire>
						</div>
					</>
				);
			} else if (userID) {
				return (
					<>
						<ProductStock></ProductStock>
						<div className="c-product__buttons">
							<button className="c-product__buttons__button" disabled>Add To Cart</button>
							<ProductEnquire title={item.title} sku={item.sku} butClass={"c-product__buttons__button c-product__buttons__button--outline"}></ProductEnquire>
						</div>
					</>
				);
			} else {
				 return (
				 	<div className="c-product__buttons">
				 		<ProductEnquire title={item.title} sku={item.sku} butClass={"c-product__buttons__button"}></ProductEnquire>
				 		<button className="c-product__buttons__button c-product__buttons__button--outline" onClick={toggleLogin}>Trade Login</button>
				 	</div>
				 );
			}
		}
		
		function addToCart() {
			context.editCart(item, 1, true);
			document.getElementsByClassName('c-header__buttons__cart')[0].click();
		}
	
	    let theContent = ''; 
	    
		if (item) {
			
		    return (
			    <div className={pageClass}>
			        <div id={'product-' + item.id} className="c-product">
			        	<div className="l-content">
			        		<div className="l-grid">
			        			<div className="l-grid__col l-grid__col--l-6-12">
									<div className="c-product__gallery">
										<ProductGallery item={item}></ProductGallery>
									</div>
								</div>
								<div className="l-grid__col l-grid__col--l-6-12">
									<div className="c-product__info">
						        		<header>
						        			{item.tagline &&
							        			<h3 className="c-product__tagline" dangerouslySetInnerHTML={ {__html: item.tagline} }></h3>
							        		}
						        			{item.subheading &&
							        			<h2 className="c-product__subheading" dangerouslySetInnerHTML={ {__html: item.subheading} }></h2>
							        		}
							        		{item.heading &&
												<h1 className="c-product__heading" dangerouslySetInnerHTML={ {__html: item.heading} }></h1>
											}									
										</header>
										{item.indent_message &&
											<div className="c-product__indent" dangerouslySetInnerHTML={{__html: item.indent_message}}></div>
										}
										{item.sku &&
											<p className="c-product__code">Product code: {item.sku}</p>
										}
										
										<Pricing></Pricing>
										{item.variation && 
											<ProductSelect item={item}></ProductSelect>
										}
										{item.default_fabric &&
											<p className="c-product__defaut-fabric" dangerouslySetInnerHTML={ {__html: 'Shade as shown <strong>' + item.default_fabric + '</strong>'} }></p>
										}
										{item.fabric &&
											<ProductFabrics fabric={item.fabric}></ProductFabrics>
			        					}
			        					<div className="c-product__functions">
											<ProductShare item={item}></ProductShare>
											<ProductDownload></ProductDownload>
										</div>
										{item.disclaimer &&
											<div className="c-product__disclaimer" dangerouslySetInnerHTML={{__html: item.disclaimer }}></div>
										}
										<ProductInfo item={item}></ProductInfo>
										<ProductButtons></ProductButtons>
										
										{item.standards &&
											<div className="c-product__standards">
												<div className="scope-text scope-text--standards" dangerouslySetInnerHTML={{__html: item.standards }}></div>
											</div>
										}
									</div>
								</div>
							</div>
						</div>
						{item.related &&
							<div className="c-product-gallery">
								<div className="l-content">
				        			<div className="l-grid">
				        				<div className="l-grid__col">
				        					<h2 className="c-product-gallery__heading">Related</h2>
				        					<ProductRelated item={item}></ProductRelated>
				        				</div>
				        			</div>
				        		</div>
							</div>
				        }
			        </div>
			        
			        <Foot></Foot>
				</div>
			);
		} else {
			return null;
		}

	} else {
		return null;
	}
};
export default WithConsumer(Product);